// extracted by mini-css-extract-plugin
export default {"c":"space_c__RmjoE"};